import { render } from "./MobileTab.vue?vue&type=template&id=240ed69c"
import script from "./MobileTab.vue?vue&type=script&lang=js"
export * from "./MobileTab.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__